// extracted by mini-css-extract-plugin
export default {"root":"CustomEmpty_root__7IMd1"};